import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import type { OwaDate } from 'owa-datetime';
import type AccountsEditorStore from './schema/AccountsEditorState';

const defaultAccountsEditorStore: AccountsEditorStore = {
    accountPendingTrueTimeUpdate: null,
    trueTimeUpdateFailedAccount: null,
    accountsEditorState: 0,
    connectAccountAttempted: false,
    selectedAccountProvider: null,
    source: null,
    accountCalendarsLoadStartTime: null,
    owaSessionAddedAccountsTimestamps: new ObservableMap<string, OwaDate>(),
    editorSessionAddedAccounts: [],
    accountErrorReferralAccounts: [],
};

export const getStore = createStore<AccountsEditorStore>(
    'accountsEditorStore',
    defaultAccountsEditorStore
);
export default getStore;
